import { FC } from 'react';
import Container from '~/components/Container';
import Divider from '~/components/Divider';
import Colors from '~/constants/colors';
import styles from './ProductMatching.module.scss';
interface ProductMatchingProps {
    data?: any;
}

const ProductMatching: FC<ProductMatchingProps> = ({ data }) => {
    const _cmsBlock = data?.content;
    const _title = data?.title;

    // if (!isClient) {
    //     return <ProductMatchingSkeleton />;
    // }
    // if (loading) {
    //     return <ProductMatchingSkeleton />;
    // }
    if (!_cmsBlock) {
        return null;
    }

    return (
        <Container rootClassName={styles.shoes_matching_wrapper} className={styles.shoes_matching}>
            <div className="flex flex-col gap-3">
                <Divider
                    text={_title}
                    className="text-xl lg:text-3xl font-bold text-gray-900"
                    dividerColor={Colors.DIVIDER_COLOR}
                />
            </div>
            {_cmsBlock && <div dangerouslySetInnerHTML={{ __html: _cmsBlock }} />}
        </Container>
    );
};

export default ProductMatching;
